import React from 'react';
import HeroBanner from '../components/tw1/HeroBanner';
import { Landmark, ExternalLink, AlertTriangle, Info, Clock } from 'lucide-react';
import { Button } from '../components/ui/button';
import { EXACT_LOGO } from '../lib/logos';

const C = '#0891b2';

export default function IncassosPage() {
  return (
    <div className="tw1-fade-in" data-testid="incassos-page">
      <HeroBanner title="Incasso's Exact" subtitle="Handleiding incasso's verrichten via Exact Online" variant="teal" icon={Landmark} logos={[{ src: EXACT_LOGO, alt: 'Exact' }]} />

      <div className="space-y-5">
        {/* Stappen */}
        <div className="tw1-card p-5" data-testid="incassos-steps">
          <h2 className="text-sm font-bold text-[#0b1220] mb-4">Stappen</h2>
          <div className="space-y-3">
            {[
              { n: 1, text: 'Open Exact Online → Financieel → Bank en Kas' },
              { n: 2, text: 'Klik op "Incasso selecteren"' },
              { n: 3, text: 'Selecteer de incasso\'s die je wilt verrichten' },
            ].map(s => (
              <div key={s.n} className="flex items-start gap-3">
                <div className="w-7 h-7 rounded-lg flex items-center justify-center shrink-0 text-xs font-bold text-white" style={{ background: C }}>{s.n}</div>
                <p className="text-sm text-[#3a4553] pt-1">{s.text}</p>
              </div>
            ))}

            {/* Waarschuwing */}
            <div className="flex items-start gap-3 bg-red-50 border border-red-200 rounded-xl p-3 ml-10" data-testid="incassos-warning">
              <AlertTriangle className="w-5 h-5 text-[#c0392b] shrink-0 mt-0.5" />
              <p className="text-sm font-semibold text-[#c0392b]">Negatieve bedragen (creditnota's) NIET aanvinken!</p>
            </div>

            {[
              { n: 5, text: 'Klik op "Verrichten"' },
              { n: 6, text: 'Klik op "Overdragen aan ING"' },
            ].map(s => (
              <div key={s.n} className="flex items-start gap-3">
                <div className="w-7 h-7 rounded-lg flex items-center justify-center shrink-0 text-xs font-bold text-white" style={{ background: C }}>{s.n}</div>
                <p className="text-sm text-[#3a4553] pt-1">{s.text}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Tips */}
        <div className="tw1-card p-5" data-testid="incassos-tips">
          <div className="flex items-center gap-2 mb-3">
            <Info className="w-4 h-4" style={{ color: C }} />
            <h2 className="text-sm font-bold text-[#0b1220]">Tips & aandachtspunten</h2>
          </div>
          <ul className="space-y-2.5">
            {[
              'Europese machtiging mist? → Relatie opzoeken → incassomachtiging invoeren',
              'Na het overdragen: 5 werkdagen wachten → dan accepteren bij de bank',
              'Accepteren moet vóór 15:00',
              'Weekend telt NIET mee bij de 5 werkdagen',
            ].map((tip, i) => (
              <li key={i} className="flex items-start gap-2">
                <div className="w-1.5 h-1.5 rounded-full mt-1.5 shrink-0" style={{ background: C }} />
                <p className="text-sm text-[#3a4553]">{tip}</p>
              </li>
            ))}
          </ul>
        </div>

        {/* Schema */}
        <div className="tw1-card p-5" data-testid="incassos-schema">
          <div className="flex items-center gap-2 mb-3">
            <Clock className="w-4 h-4" style={{ color: C }} />
            <h2 className="text-sm font-bold text-[#0b1220]">Schema</h2>
          </div>
          <div className="rounded-lg p-3 text-sm text-[#3a4553]" style={{ background: `${C}08` }}>
            Na overdragen aan ING: <strong>5 werkdagen wachten</strong>, dan accepteren vóór <strong>15:00</strong>. Weekend telt niet mee.
          </div>
        </div>

        {/* Snelkoppelingen */}
        <div className="tw1-card p-5" data-testid="incassos-links">
          <h2 className="text-sm font-bold text-[#0b1220] mb-3">Snelkoppelingen</h2>
          <a href="https://start.exactonline.nl" target="_blank" rel="noopener noreferrer">
            <Button className="text-white text-sm" style={{ background: C }} data-testid="incassos-exact-link">
              <ExternalLink className="w-4 h-4 mr-2" /> Open Exact Online
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
}
